import React, { Component } from "react";
import { Page } from "pages/page";
import policy from "pages/policy";
import { faHome, faExternalLinkAlt, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./index.module.scss";

class Home extends Component {
	public render (): JSX.Element {
		return <div className={ styles.wrapper }>
			<section className={ styles.hero }>
				<h1 className={ styles.headline }>Fangame Archive</h1>
				<p className={ styles.tagline }>
					Preserving the lost fangames of <strong>I Wanna Be The Guy</strong>
				</p>
			</section>

			<section className={ styles.cards }>
				<a
					href="https://delicious-fruit.com/"
					className={ styles.card }
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className={ styles.cardIcon }>
						<FontAwesomeIcon icon={ faExternalLinkAlt } />
					</span>
					<div className={ styles.cardContent }>
						<h3>delicious-fruit</h3>
						<p>Search for fangames on the main community hub</p>
					</div>
				</a>
				<a href={ `/${ policy.getURL() }` } className={ styles.card }>
					<span className={ styles.cardIcon }>
						<FontAwesomeIcon icon={ faFileAlt } />
					</span>
					<div className={ styles.cardContent }>
						<h3>Policy</h3>
						<p>Learn about our archiving guidelines</p>
					</div>
				</a>
			</section>

			<p className={ styles.signoff }>Enjoy your stay!</p>
		</div>;
	}
}

const page = new Page({
	name: "Home",
	content: <Home />,
	default: true,
	icon: faHome,
	title: false,
});

export default page;
